"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.submitEnquiryByEmail = exports.submitEnquiryByWhatsapp = exports.hasNameAndOneOfPhoneOrEmail = exports.getEmail = exports.getCountryCode = exports.getPhone = exports.getName = exports.checkPhone = exports.checkName = exports.checkEmail = exports.getEnquiryType = exports.forceSaveSearch = exports.enquireSagas = void 0;
var effects_1 = require("redux-saga/effects");
var EnquireApiToken_1 = require("@/api/remote/protected/EnquireApiToken");
var transformEnquiryToRequest_1 = require("@/transformers/transformEnquiryToRequest");
var StorageApi_1 = require("@/api/browser/StorageApi");
var GlobalAction_1 = require("@/pages/common/actions/GlobalAction");
var WindowApi_1 = require("@/api/browser/WindowApi");
var stateFilter_1 = require("@/pages/common/sagas/stateFilter");
var SignupApiSaga_1 = require("@/pages/search/sagas/api/SignupApiSaga");
var ExistingLoginAction_1 = require("@/pages/search/actions/sfilter/ExistingLoginAction");
var UserAction_1 = require("@/pages/common/actions/UserAction");
var SfilterUpdateAction_1 = require("@/pages/search/actions/sfilter/SfilterUpdateAction");
var LoginAction_1 = require("@/pages/common/actions/LoginAction");
var BigPopupState_1 = require("@/pages/common/states/BigPopupState");
var LayoutAction_1 = require("@/pages/common/actions/LayoutAction");
var EnquireAction_1 = require("@/pages/common/actions/EnquireAction");
var RecaptureAction_1 = require("@/pages/search/actions/sfilter/RecaptureAction");
var Pages_1 = require("@/rendering/common/Pages");
var transformOfficeInfoToReplyBar_1 = require("@/transformers/transformOfficeInfoToReplyBar");
var EnqurieCallToActionType_1 = require("@/pages/common/states/EnqurieCallToActionType");
var DetailCallSaga_1 = require("@/pages/detail/sagas/DetailCallSaga");
var EnquireApiSaga_1 = require("@/pages/common/sagas/api/EnquireApiSaga");
var EnquireSagaCall_1 = require("@/pages/search/sagas/EnquireSagaCall");
var SignupCallSaga_1 = require("@/pages/common/sagas/SignupCallSaga");
var SavePropertiesApiSaga_1 = require("@/pages/saveproperties/sagas/api/SavePropertiesApiSaga");
var EnquiryFormActions_1 = require("@/pages/common/actions/EnquiryFormActions");
var Validator_1 = require("@/utils/Validator");
var UserPropertiesCrud_1 = require("@/pages/saveproperties/sagas/UserPropertiesCrud");
var filterRelavantFavoriteProperty_1 = require("@/pages/search/transformers/filterRelavantFavoriteProperty");
var sortByCreatedDate_1 = require("@/pages/saveproperties/transformer/sortByCreatedDate");
var getName = function (state) { return state.enquire.enquiry.fullname; };
exports.getName = getName;
var getEmail = function (state) { return state.enquire.enquiry.email; };
exports.getEmail = getEmail;
var getPhone = function (state) { return state.enquire.enquiry.phone; };
exports.getPhone = getPhone;
var getCountryCode = function (state) { return state.enquire.enquiry.countryCode || '852'; };
exports.getCountryCode = getCountryCode;
var getEnquiryCurrent = function (state) { return state.enquire.current; };
var getEnquiry = function (state) { return state.enquire; };
var getForm = function (state) { return state.enquire.enquiry; };
var getEnquiryFavs = function (state) { return state.enquire.favorites; };
var getEnquiryFavsInt = function (state) { return state.enquire.favoritesInt; };
var getEnquiryUser = function (state) { return state.user; };
var getEnquiryType = function (state) {
    if (state.page === Pages_1.Pages.DEVELOPMENT)
        return EnquireApiToken_1.EnquireRequestType.Firsthand_Property;
    if (state.page === Pages_1.Pages.DEVELOPMENTS)
        return EnquireApiToken_1.EnquireRequestType.Firsthand_Properties;
    if (state.page === Pages_1.Pages.PROPERTY_DETAIL)
        return EnquireApiToken_1.EnquireRequestType.Property_Details;
    if (state.enquire.current)
        return EnquireApiToken_1.EnquireRequestType.Search_Property_Listing;
    if (state.page === Pages_1.Pages.SEARCH)
        return EnquireApiToken_1.EnquireRequestType.Search_Property;
    return EnquireApiToken_1.EnquireRequestType.General;
};
exports.getEnquiryType = getEnquiryType;
var shouldForceSaveSearch = function (state) { return state.page === Pages_1.Pages.SEARCH; };
var fillCreatedAt = function (newFavorites, favProperties) { return function (it) {
    var originalProperty = newFavorites.find(function (it2) { return Number(it2.referenceId) === Number(it); });
    var createdAtStr = (originalProperty ? new Date(originalProperty.createdDate) : new Date()).toISOString();
    return __assign(__assign({}, favProperties.find(function (it2) { return Number(it2.id) === Number(it); })), { createdAt: createdAtStr });
}; };
var primaryPhotoFirst = function (a, b) {
    if (typeof a === 'string' || typeof b === 'string')
        return 0;
    if (a.isPrimary && !b.isPrimary) {
        return -1;
    }
    if (b.isPrimary && !a.isPrimary) {
        return 1;
    }
    return 0;
};
var trimPhoto = function (n) { return function (it) {
    var newProperty = it.propertyPhotos !== undefined ? __assign(__assign({}, it), { propertyPhotos: it.propertyPhotos.sort(primaryPhotoFirst).slice(0, n) }) : it;
    if (newProperty.propertyPhotoImages !== undefined) {
        newProperty.propertyPhotoImages = newProperty.propertyPhotoImages.slice(0, n);
    }
    return newProperty;
}; };
var getRequestBody = function (enquiry, favorites, favoritesInt, user, currentUrl, currencyId, enquireType, current) {
    function distinct(value, index, array) {
        return array.indexOf(value) === index;
    }
    var FAV_SIZE, newFavorites, newFavoritesInt, favIds, favIntIds, favResponse, favIntResponse, favProperties, favIntProperties, requestBody, okeid, eid, edmid, rid;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                FAV_SIZE = 10;
                newFavorites = favorites ? favorites : [];
                newFavoritesInt = favoritesInt ? favoritesInt : [];
                favIds = __spreadArrays([
                    current ? current.referenceId : null
                ], newFavorites.map(function (it) { return it.referenceId; })).filter(function (it) { return it; }).filter(distinct);
                favIntIds = favoritesInt.map(function (it) { return it.referenceId; }).filter(function (it) { return it; });
                return [4 /*yield*/, effects_1.call(SavePropertiesApiSaga_1.getPropertiesDetailByIdsApi, favIds)];
            case 1:
                favResponse = _a.sent();
                favIntResponse = { data: { intProperties: null } };
                if (!(favIntIds.length > 0)) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.call(SavePropertiesApiSaga_1.getPropertiesDetailByIdsApi, favIntIds)];
            case 2:
                favIntResponse =
                    _a.sent();
                _a.label = 3;
            case 3:
                favProperties = [];
                favIntProperties = [];
                if (favResponse && favResponse.data.properties && favResponse.data.properties.length) {
                    favProperties = favResponse.data.properties;
                }
                if (favIntResponse && favIntResponse.data.intProperties && favIntResponse.data.intProperties.length) {
                    favIntProperties = favIntResponse.data.intProperties;
                }
                // Fill createdAt
                favProperties = favIds.map(fillCreatedAt(newFavorites, favProperties));
                favIntProperties = favIntIds.map(fillCreatedAt(newFavoritesInt, favIntProperties));
                // Trim photo to 2
                favProperties = favProperties.map(trimPhoto(2));
                favIntProperties = favIntProperties.map(trimPhoto(2));
                favProperties = favProperties.slice(0, FAV_SIZE + 1);
                favIntProperties = favIntProperties.slice(0, FAV_SIZE + 1);
                return [4 /*yield*/, effects_1.call(transformEnquiryToRequest_1.transformEnquiryToRequest, enquiry, favProperties, favIntProperties, user, currentUrl, currencyId, enquireType)];
            case 4:
                requestBody = _a.sent();
                return [4 /*yield*/, effects_1.call(StorageApi_1.readCookie, 'okeid')];
            case 5:
                okeid = _a.sent();
                return [4 /*yield*/, effects_1.call(StorageApi_1.readCookie, 'eid')];
            case 6:
                eid = _a.sent();
                if (eid && okeid) {
                    requestBody.enquiryData.emailId = okeid + "|" + eid;
                }
                else if (eid) {
                    requestBody.enquiryData.emailId = eid;
                }
                else if (okeid) {
                    requestBody.enquiryData.emailId = okeid;
                }
                return [4 /*yield*/, effects_1.call(StorageApi_1.readCookie, 'edmid')];
            case 7:
                edmid = _a.sent();
                if (edmid)
                    requestBody.enquiryData.edmId = edmid;
                return [4 /*yield*/, effects_1.call(StorageApi_1.readCookie, 'rid')];
            case 8:
                rid = _a.sent();
                if (rid)
                    requestBody.enquiryData.referralId = rid;
                return [2 /*return*/, requestBody];
        }
    });
};
var logEnquiry = function (enquiry, favorites, favoritesInt, recentlyViewed, user, currentUrl, currencyId, enquireType, ctaType, current) {
    var forRentSaleType, relevantFavorites, requestBody, languageCode, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                forRentSaleType = current === null ? null : current.type;
                relevantFavorites = favorites.filter(filterRelavantFavoriteProperty_1.filterRelevantFavoriteProperty(forRentSaleType)).sort(sortByCreatedDate_1.sortByCreatedDate);
                return [4 /*yield*/, effects_1.call(getRequestBody, enquiry, relevantFavorites, favoritesInt, user, currentUrl, currencyId, enquireType, current)];
            case 1:
                requestBody = _a.sent();
                requestBody.enquiryCommMediaType = ctaType;
                return [4 /*yield*/, effects_1.select(stateFilter_1.getCurrentLanguageCode)];
            case 2:
                languageCode = _a.sent();
                return [4 /*yield*/, effects_1.call(EnquireApiSaga_1.enquiryCallToActionApi, requestBody, languageCode)];
            case 3:
                response = _a.sent();
                if (!!response) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.put(GlobalAction_1.default.setMessageLocalized('apiCallError'))];
            case 4:
                _a.sent();
                return [3 /*break*/, 8];
            case 5: return [4 /*yield*/, effects_1.put(EnquireAction_1.default.setLastEnquiry({ request: requestBody, response: response.data }))];
            case 6:
                _a.sent();
                return [4 /*yield*/, effects_1.put(GlobalAction_1.default.setBigPopupLocalized('enquiry_success', BigPopupState_1.BigPopupType.SUCCESS, 'success', 'enquireSuccess', 'close'))];
            case 7:
                _a.sent();
                _a.label = 8;
            case 8: return [2 /*return*/, response];
        }
    });
};
var doEnquiry = function (enquiry, favorites, favoritesInt, recentlyViewed, user, currentUrl, currencyId, enquireType, current) {
    var forRentSaleType, relevantFavorites, requestBody, languageCode, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                forRentSaleType = current === null ? null : current.type;
                relevantFavorites = favorites.filter(filterRelavantFavoriteProperty_1.filterRelevantFavoriteProperty(forRentSaleType)).sort(sortByCreatedDate_1.sortByCreatedDate);
                return [4 /*yield*/, effects_1.call(getRequestBody, enquiry, relevantFavorites, favoritesInt, user, currentUrl, currencyId, enquireType, current)];
            case 1:
                requestBody = _a.sent();
                return [4 /*yield*/, effects_1.select(stateFilter_1.getCurrentLanguageCode)];
            case 2:
                languageCode = _a.sent();
                return [4 /*yield*/, effects_1.call(EnquireApiSaga_1.enquireApiSubmit, requestBody, languageCode)];
            case 3:
                response = _a.sent();
                if (!!response) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.put(GlobalAction_1.default.setMessageLocalized('apiCallError'))];
            case 4:
                _a.sent();
                return [3 /*break*/, 8];
            case 5: return [4 /*yield*/, effects_1.put(EnquireAction_1.default.setLastEnquiry({ request: requestBody, response: response.data }))];
            case 6:
                _a.sent();
                return [4 /*yield*/, effects_1.put(GlobalAction_1.default.setBigPopupLocalized('enquiry_success', BigPopupState_1.BigPopupType.SUCCESS, 'success', 'enquireSuccess', 'close'))];
            case 7:
                _a.sent();
                _a.label = 8;
            case 8: return [2 /*return*/, response];
        }
    });
};
var watchOnEnquireCloseClick = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.take(EnquireAction_1.default.ON_ENQUIRE_CLOSE_CLICK)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(EnquireAction_1.default.setEnquireActive(false))];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.delay(100)];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.put(EnquireAction_1.default.setEnquireDim(false))];
            case 4:
                _a.sent();
                return [3 /*break*/, 0];
            case 5: return [2 /*return*/];
        }
    });
};
var forceSaveSearch = function (field) {
    var isGuest, response, silent, accountCreateSuccess;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.call(EnquireSagaCall_1.saveSearchSetToLocalStorage, field.email)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(stateFilter_1.isUserGuest)];
            case 2:
                isGuest = _a.sent();
                if (!!isGuest) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.call(EnquireSagaCall_1.saveSearchFromLocalStorage)];
            case 3:
                _a.sent();
                return [2 /*return*/];
            case 4: return [4 /*yield*/, effects_1.call(SignupApiSaga_1.signupApi, field)];
            case 5:
                response = _a.sent();
                silent = true;
                return [4 /*yield*/, effects_1.call(SignupCallSaga_1.handleSignupResponse, response, silent)];
            case 6:
                accountCreateSuccess = _a.sent();
                if (!accountCreateSuccess) return [3 /*break*/, 8];
                return [4 /*yield*/, effects_1.call(EnquireSagaCall_1.saveSearchFromLocalStorage)];
            case 7:
                _a.sent();
                _a.label = 8;
            case 8: return [2 /*return*/];
        }
    });
};
exports.forceSaveSearch = forceSaveSearch;
var postEnquiryAction = function (response, enquiry) {
    var accountReference, hasAccount, isGuest, loginProviderObj, loginProviderString, isForceSaveSearch;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                accountReference = response.data.processedData.references ?
                    response.data.processedData.references.find(function (it) { return it.name === 'HasAccount'; }) : null;
                hasAccount = accountReference ? accountReference.value : 'false';
                if (!(hasAccount === 'true')) return [3 /*break*/, 9];
                return [4 /*yield*/, effects_1.select(stateFilter_1.isUserGuest)];
            case 1:
                isGuest = _a.sent();
                if (!isGuest) return [3 /*break*/, 8];
                loginProviderObj = response.data.processedData.references
                    .find(function (it) { return it.name === 'LoginProvider'; });
                loginProviderString = loginProviderObj ? loginProviderObj.value : null;
                if (!loginProviderString) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.put(ExistingLoginAction_1.default.setLoginProvider(loginProviderString))];
            case 2:
                _a.sent();
                return [3 /*break*/, 5];
            case 3: return [4 /*yield*/, effects_1.put(ExistingLoginAction_1.default.setLoginProvider(''))];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5: return [4 /*yield*/, effects_1.put(ExistingLoginAction_1.default.setEmail(enquiry.email))];
            case 6:
                _a.sent();
                return [4 /*yield*/, effects_1.put(ExistingLoginAction_1.default.show())];
            case 7:
                _a.sent();
                _a.label = 8;
            case 8: return [3 /*break*/, 12];
            case 9: return [4 /*yield*/, effects_1.select(shouldForceSaveSearch)];
            case 10:
                isForceSaveSearch = _a.sent();
                if (!(isForceSaveSearch && enquiry.email)) return [3 /*break*/, 12];
                return [4 /*yield*/, effects_1.call(forceSaveSearch, {
                        email: enquiry.email,
                        firstName: enquiry.firstname,
                        lastName: enquiry.lastname,
                        salutation: enquiry.salutation,
                        phone: enquiry.phone,
                        receiveNewsletter: enquiry.update,
                    })];
            case 11:
                _a.sent();
                _a.label = 12;
            case 12: return [2 /*return*/];
        }
    });
};
var closeEnquiryPopup = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.put(EnquireAction_1.default.setEnquireActive(false))];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.delay(100)];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.put(EnquireAction_1.default.setEnquireDim(false))];
            case 3:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var getEnquiryResultItemFavs = function () {
    var properties;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.call(UserPropertiesCrud_1.getSavedProperties, 1, 120)];
            case 1:
                properties = (_a.sent()).properties;
                return [2 /*return*/, properties];
        }
    });
};
var watchOnEnquireSubmit = function () {
    var payload, enquiry, current, favorites, favoritesInt, recentlyViewedFirstPage, recentlyViewed, user, currentUrl, currencyId, type, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 18];
                return [4 /*yield*/, effects_1.take(EnquireAction_1.default.ON_ENQUIRE_SUBMIT)];
            case 1:
                payload = (_a.sent()).payload;
                enquiry = payload.form;
                return [4 /*yield*/, effects_1.select(getEnquiryCurrent)];
            case 2:
                current = _a.sent();
                return [4 /*yield*/, effects_1.call(getEnquiryResultItemFavs)];
            case 3:
                favorites = _a.sent();
                favoritesInt = [];
                return [4 /*yield*/, effects_1.call(UserPropertiesCrud_1.getRecentlyViewed, 1)];
            case 4:
                recentlyViewedFirstPage = _a.sent();
                recentlyViewed = recentlyViewedFirstPage ? recentlyViewedFirstPage.properties : [];
                return [4 /*yield*/, effects_1.select(getEnquiryUser)];
            case 5:
                user = _a.sent();
                return [4 /*yield*/, effects_1.call(WindowApi_1.getCurrentUrl)];
            case 6:
                currentUrl = _a.sent();
                return [4 /*yield*/, effects_1.select(stateFilter_1.getCurrentCurrency)];
            case 7:
                currencyId = _a.sent();
                return [4 /*yield*/, effects_1.select(getEnquiryType)];
            case 8:
                type = _a.sent();
                return [4 /*yield*/, effects_1.put(EnquireAction_1.default.setLoading(true))];
            case 9:
                _a.sent();
                return [4 /*yield*/, effects_1.call(doEnquiry, enquiry, favorites, favoritesInt, recentlyViewed, user, currentUrl, currencyId, type, current)];
            case 10:
                response = _a.sent();
                if (!stateFilter_1.isUserGuest) return [3 /*break*/, 12];
                return [4 /*yield*/, effects_1.call(EnquireSagaCall_1.saveEnquireFormToLocalStorage, enquiry)];
            case 11:
                _a.sent();
                _a.label = 12;
            case 12:
                if (!!response) return [3 /*break*/, 14];
                return [4 /*yield*/, effects_1.put(EnquireAction_1.default.setLoading(false))];
            case 13:
                _a.sent();
                return [3 /*break*/, 0];
            case 14: return [4 /*yield*/, effects_1.call(postEnquiryAction, response, enquiry)];
            case 15:
                _a.sent();
                return [4 /*yield*/, effects_1.put(EnquireAction_1.default.setLoading(false))];
            case 16:
                _a.sent();
                return [4 /*yield*/, effects_1.call(closeEnquiryPopup)];
            case 17:
                _a.sent();
                return [3 /*break*/, 0];
            case 18: return [2 /*return*/];
        }
    });
};
var watchOnEnquireTop = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(EnquireAction_1.default.SET_ENQUIRE_TOP)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.call(WindowApi_1.scrollToEnquireTop)];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchOnSetUser = function () {
    var payload, user;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(UserAction_1.default.SET_USER_DONE)];
            case 1:
                payload = (_a.sent()).payload;
                return [4 /*yield*/, effects_1.call(EnquireSagaCall_1.popEnquireFormFromLocalStorage)];
            case 2:
                _a.sent();
                user = payload;
                return [4 /*yield*/, effects_1.put(EnquireAction_1.default.setForm({
                        email: user.email,
                        firstname: user.firstname,
                        lastname: user.lastname,
                        fullname: (user.firstname + " " + user.lastname).trim(),
                        salutation: user.salutation,
                        phone: user.phone,
                        countryCode: user.countryCode || '852',
                    }))];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
var watchFilterChangePopSaveSearchFromLocalStorage = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(SfilterUpdateAction_1.default.FILTER_UPDATE)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.call(EnquireSagaCall_1.popSaveSearchFromLocalStorage)];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchAfterEnquireNoLogin = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.take(ExistingLoginAction_1.default.ON_EXISTING_CLOSE_CLICK)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(LoginAction_1.default.setEmail(''))];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.put(ExistingLoginAction_1.default.setEmail(''))];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.put(ExistingLoginAction_1.default.setLoginProvider(''))];
            case 4:
                _a.sent();
                return [4 /*yield*/, effects_1.call(EnquireSagaCall_1.popSaveSearchFromLocalStorage)];
            case 5:
                _a.sent();
                return [3 /*break*/, 0];
            case 6: return [2 /*return*/];
        }
    });
};
var watchAfterEnquireCancelLoginSaga = function () {
    var close;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.take(ExistingLoginAction_1.default.ON_EXISTING_LOGIN_CLICK)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.race({
                        login: effects_1.take(LoginAction_1.default.ON_LOGIN_SUBMIT),
                        close: effects_1.take(LoginAction_1.default.ON_LOGIN_CLOSE_CLICK),
                    })];
            case 2:
                close = (_a.sent()).close;
                if (!close) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.call(EnquireSagaCall_1.popSaveSearchFromLocalStorage)];
            case 3:
                _a.sent();
                _a.label = 4;
            case 4: return [3 /*break*/, 0];
            case 5: return [2 /*return*/];
        }
    });
};
var watchOnEnquireClicked = function () {
    var payload, isGuest, enquireForm;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 15];
                return [4 /*yield*/, effects_1.take([
                        EnquireAction_1.default.ON_ENQUIRE_CLICK,
                    ])];
            case 1:
                payload = (_a.sent()).payload;
                return [4 /*yield*/, effects_1.put(EnquireAction_1.default.setLastEnquiry(null))];
            case 2:
                _a.sent();
                if (!payload) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.put(EnquireAction_1.default.setCurrent(payload))];
            case 3:
                _a.sent();
                return [3 /*break*/, 6];
            case 4: return [4 /*yield*/, effects_1.put(EnquireAction_1.default.setCurrent(null))];
            case 5:
                _a.sent();
                _a.label = 6;
            case 6: return [4 /*yield*/, effects_1.put(EnquireAction_1.default.setEnquireDim(true))];
            case 7:
                _a.sent();
                return [4 /*yield*/, effects_1.delay(100)];
            case 8:
                _a.sent();
                return [4 /*yield*/, effects_1.put(EnquireAction_1.default.setEnquireActive(true))];
            case 9:
                _a.sent();
                return [4 /*yield*/, effects_1.put(EnquireAction_1.default.setEnquireTop())];
            case 10:
                _a.sent();
                return [4 /*yield*/, effects_1.select(stateFilter_1.isUserGuest)];
            case 11:
                isGuest = _a.sent();
                return [4 /*yield*/, effects_1.call(EnquireSagaCall_1.loadEnquireFormFromLocalStorage)];
            case 12:
                enquireForm = _a.sent();
                if (!(isGuest && enquireForm)) return [3 /*break*/, 14];
                return [4 /*yield*/, effects_1.put(EnquireAction_1.default.setForm(enquireForm))];
            case 13:
                _a.sent();
                _a.label = 14;
            case 14: return [3 /*break*/, 0];
            case 15: return [2 /*return*/];
        }
    });
};
var watchOnContactNumberClicked = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(LayoutAction_1.default.ON_CONTACT_CLICKED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(EnquireAction_1.default.onEnquireClick())];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
/*  Show recapture when user closes the enquiry box */
var watchEnquireClose = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(EnquireAction_1.default.ON_ENQUIRE_CLOSE_CLICK)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(RecaptureAction_1.default.doRecapture())];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchUpdateReplybar = function () {
    var languageCode, result, officeInfo, replyBarState, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 9];
                return [4 /*yield*/, effects_1.take(EnquireAction_1.default.UPDATE_REPLY_BAR)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(stateFilter_1.getCurrentLanguageCode)];
            case 2:
                languageCode = _a.sent();
                _a.label = 3;
            case 3:
                _a.trys.push([3, 7, , 8]);
                return [4 /*yield*/, effects_1.call(EnquireApiToken_1.enquireGetOfficeInfo, languageCode)];
            case 4:
                result = _a.sent();
                officeInfo = result.data;
                return [4 /*yield*/, effects_1.call(transformOfficeInfoToReplyBar_1.transformOfficeInfoToReplyBar, officeInfo)];
            case 5:
                replyBarState = _a.sent();
                return [4 /*yield*/, effects_1.put(EnquireAction_1.default.setReplybar(replyBarState))];
            case 6:
                _a.sent();
                return [3 /*break*/, 8];
            case 7:
                e_1 = _a.sent();
                return [3 /*break*/, 8];
            case 8: return [3 /*break*/, 0];
            case 9: return [2 /*return*/];
        }
    });
};
var watchEnquireCallToAction = function () {
    var payload, type, isValid;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(EnquireAction_1.default.ON_ENQUIRE_CALL_TO_ACTION_CLICK)];
            case 1:
                payload = (_a.sent()).payload;
                type = payload;
                return [4 /*yield*/, effects_1.call(hasNameAndOneOfPhoneOrEmail)];
            case 2:
                isValid = _a.sent();
                if (!isValid)
                    return [3 /*break*/, 0];
                return [4 /*yield*/, effects_1.put(EnquireAction_1.default.callToAction(type))];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
var doCallToActionWhatsapp = function () {
    var ctaType, enquire, current, favorites, favoritesInt, recentlyViewedFirstPage, recentlyViewed, user, currentUrl, currencyId, type, enquireForm, response, enquireState, enquiryId, whatsappUrl;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                ctaType = EnqurieCallToActionType_1.EnqurieCallToActionType.WhatsApp;
                return [4 /*yield*/, effects_1.select(getEnquiry)];
            case 1:
                enquire = _a.sent();
                return [4 /*yield*/, effects_1.select(getEnquiryCurrent)];
            case 2:
                current = _a.sent();
                return [4 /*yield*/, effects_1.call(getEnquiryResultItemFavs)];
            case 3:
                favorites = _a.sent();
                return [4 /*yield*/, effects_1.select(getEnquiryFavsInt)];
            case 4:
                favoritesInt = _a.sent();
                return [4 /*yield*/, effects_1.call(UserPropertiesCrud_1.getRecentlyViewed, 1)];
            case 5:
                recentlyViewedFirstPage = _a.sent();
                recentlyViewed = recentlyViewedFirstPage ? recentlyViewedFirstPage.properties : [];
                return [4 /*yield*/, effects_1.select(getEnquiryUser)];
            case 6:
                user = _a.sent();
                return [4 /*yield*/, effects_1.call(WindowApi_1.getCurrentUrl)];
            case 7:
                currentUrl = _a.sent();
                return [4 /*yield*/, effects_1.select(stateFilter_1.getCurrentCurrency)];
            case 8:
                currencyId = _a.sent();
                return [4 /*yield*/, effects_1.select(getEnquiryType)];
            case 9:
                type = _a.sent();
                enquireForm = enquire.enquiry;
                return [4 /*yield*/, effects_1.put(EnquireAction_1.default.setLoading(true))];
            case 10:
                _a.sent();
                return [4 /*yield*/, effects_1.call(logEnquiry, enquireForm, favorites, favoritesInt, recentlyViewed, user, currentUrl, currencyId, type, ctaType, current)];
            case 11:
                response = _a.sent();
                if (!stateFilter_1.isUserGuest) return [3 /*break*/, 13];
                return [4 /*yield*/, effects_1.call(EnquireSagaCall_1.saveEnquireFormToLocalStorage, enquireForm)];
            case 12:
                _a.sent();
                _a.label = 13;
            case 13: return [4 /*yield*/, effects_1.select(getEnquiry)];
            case 14:
                enquireState = _a.sent();
                enquiryId = response ? (response.data.processedData.references[0].value || false) : false;
                return [4 /*yield*/, effects_1.call(DetailCallSaga_1.getWhatsappUrl, enquireState, enquiryId)];
            case 15:
                whatsappUrl = _a.sent();
                if (!whatsappUrl) return [3 /*break*/, 18];
                return [4 /*yield*/, effects_1.call(WindowApi_1.windowOpen, whatsappUrl)];
            case 16:
                _a.sent();
                return [4 /*yield*/, effects_1.call(postEnquiryAction, response, enquire.enquiry)];
            case 17:
                _a.sent();
                _a.label = 18;
            case 18: return [4 /*yield*/, effects_1.put(EnquireAction_1.default.setLoading(false))];
            case 19:
                _a.sent();
                return [4 /*yield*/, effects_1.call(closeEnquiryPopup)];
            case 20:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var doCallToActionPhone = function () {
    var ctaType, enquireState;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                ctaType = EnqurieCallToActionType_1.EnqurieCallToActionType.Phone;
                return [4 /*yield*/, effects_1.put(EnquireAction_1.default.setLoading(true))];
            case 1:
                _a.sent();
                if (!(ctaType === EnqurieCallToActionType_1.EnqurieCallToActionType.Phone)) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.select(getEnquiry)];
            case 2:
                enquireState = _a.sent();
                return [4 /*yield*/, effects_1.call(WindowApi_1.windowOpen, "tel:" + enquireState.replybar.phone.value)];
            case 3:
                _a.sent();
                _a.label = 4;
            case 4: return [4 /*yield*/, effects_1.put(EnquireAction_1.default.setLoading(false))];
            case 5:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var watchEnquireCallToActionClick = function () {
    var payload, ctaType;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.take(EnquireAction_1.default.ON_ENQUIRE_CALL_TO_ACTION)];
            case 1:
                payload = (_a.sent()).payload;
                ctaType = payload;
                if (!(ctaType === EnqurieCallToActionType_1.EnqurieCallToActionType.WhatsApp)) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.call(doCallToActionWhatsapp)];
            case 2:
                _a.sent();
                _a.label = 3;
            case 3:
                if (!(ctaType === EnqurieCallToActionType_1.EnqurieCallToActionType.Phone)) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.call(doCallToActionPhone)];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5: return [3 /*break*/, 0];
            case 6: return [2 /*return*/];
        }
    });
};
var checkName = function (force) {
    var nameStr, errorStr;
    if (force === void 0) { force = false; }
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(getName)];
            case 1:
                nameStr = _a.sent();
                if (!(nameStr || force)) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.call(Validator_1.required, nameStr)];
            case 2:
                errorStr = _a.sent();
                return [4 /*yield*/, effects_1.put(EnquiryFormActions_1.default.setFullNameError(errorStr))];
            case 3:
                _a.sent();
                return [2 /*return*/, errorStr ? false : true];
            case 4: return [2 /*return*/];
        }
    });
};
exports.checkName = checkName;
var checkPhone = function (force) {
    var phoneStr, countryCode, errorStr;
    if (force === void 0) { force = false; }
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(getPhone)];
            case 1:
                phoneStr = _a.sent();
                return [4 /*yield*/, effects_1.select(getCountryCode)];
            case 2:
                countryCode = _a.sent();
                if (!(phoneStr || force)) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.call(Validator_1.phoneForCountry, countryCode, phoneStr)];
            case 3:
                errorStr = _a.sent();
                return [4 /*yield*/, effects_1.put(EnquiryFormActions_1.default.setPhoneError(errorStr))];
            case 4:
                _a.sent();
                return [2 /*return*/, errorStr ? false : true];
            case 5: return [2 /*return*/];
        }
    });
};
exports.checkPhone = checkPhone;
var checkEmail = function (force) {
    var emailStr, errorStr;
    if (force === void 0) { force = false; }
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(getEmail)];
            case 1:
                emailStr = _a.sent();
                if (!(emailStr || force)) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.call(Validator_1.email, emailStr)];
            case 2:
                errorStr = _a.sent();
                return [4 /*yield*/, effects_1.put(EnquiryFormActions_1.default.setEmailError(errorStr))];
            case 3:
                _a.sent();
                return [2 /*return*/, errorStr ? false : true];
            case 4: return [2 /*return*/];
        }
    });
};
exports.checkEmail = checkEmail;
var watchEmailBlur = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(EnquiryFormActions_1.default.ON_EMAIL_BLUR)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.call(checkEmail)];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchPhoneBlur = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(EnquiryFormActions_1.default.ON_PHONE_BLUR)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.call(checkPhone)];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchCountryCodeChanged = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(EnquiryFormActions_1.default.ON_COUNTRYCODE_CHANGED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.call(checkPhone)];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchNameBlur = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(EnquiryFormActions_1.default.ON_FULLNAME_BLUR)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.call(checkName)];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var hasNameAndOneOfPhoneOrEmail = function () {
    var nameStr, phoneStr, emailStr, isValid, isValid, isValid;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(getName)];
            case 1:
                nameStr = _a.sent();
                return [4 /*yield*/, effects_1.select(getPhone)];
            case 2:
                phoneStr = _a.sent();
                return [4 /*yield*/, effects_1.select(getEmail)];
            case 3:
                emailStr = _a.sent();
                if (!!nameStr) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.call(checkName, true)];
            case 4:
                isValid = _a.sent();
                if (!isValid)
                    return [2 /*return*/, false];
                _a.label = 5;
            case 5:
                if (!(!phoneStr && !emailStr)) return [3 /*break*/, 7];
                return [4 /*yield*/, effects_1.call(checkPhone, true)];
            case 6:
                _a.sent();
                return [2 /*return*/, false];
            case 7:
                if (!phoneStr) return [3 /*break*/, 9];
                return [4 /*yield*/, effects_1.call(checkPhone, true)];
            case 8:
                isValid = _a.sent();
                if (!isValid)
                    return [2 /*return*/, false];
                _a.label = 9;
            case 9:
                if (!emailStr) return [3 /*break*/, 11];
                return [4 /*yield*/, effects_1.call(checkEmail, true)];
            case 10:
                isValid = _a.sent();
                if (!isValid)
                    return [2 /*return*/, false];
                _a.label = 11;
            case 11: return [2 /*return*/, true];
        }
    });
};
exports.hasNameAndOneOfPhoneOrEmail = hasNameAndOneOfPhoneOrEmail;
var submitEnquiryByEmail = function () {
    var form;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(getForm)];
            case 1:
                form = _a.sent();
                return [4 /*yield*/, effects_1.put(EnquireAction_1.default.onEnqurieSubmit(form))];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
exports.submitEnquiryByEmail = submitEnquiryByEmail;
var submitEnquiryByWhatsapp = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.put(EnquireAction_1.default.onCallToActionClicked(EnqurieCallToActionType_1.EnqurieCallToActionType.WhatsApp))];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
exports.submitEnquiryByWhatsapp = submitEnquiryByWhatsapp;
var watchOnEnquirySubmit = function () {
    var isValid;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(EnquiryFormActions_1.default.ON_ENQUIRE_SUBMIT)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.call(hasNameAndOneOfPhoneOrEmail)];
            case 2:
                isValid = _a.sent();
                if (!isValid)
                    return [3 /*break*/, 0];
                return [4 /*yield*/, effects_1.call(submitEnquiryByEmail)];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
var watchOnEnquiryContactSubmit = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(EnquiryFormActions_1.default.ON_ENQUIRE_CONTACT_SUBMIT)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(EnquiryFormActions_1.default.onEnqurieSubmit())];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchOnEnquiryWhatsAppSubmit = function () {
    var isValid;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(EnquiryFormActions_1.default.ON_ENQUIRE_WHATSAPP_SUBMIT)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.call(hasNameAndOneOfPhoneOrEmail)];
            case 2:
                isValid = _a.sent();
                if (!isValid)
                    return [3 /*break*/, 0];
                return [4 /*yield*/, effects_1.call(submitEnquiryByWhatsapp)];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
var watchPopupSetEmailDisable = function () {
    var payload, userEmail;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.take(EnquireAction_1.default.SET_ENQUIRE_ACTIVE)];
            case 1:
                payload = (_a.sent()).payload;
                if (!(payload === true)) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.select(stateFilter_1.getUserEmail)];
            case 2:
                userEmail = _a.sent();
                return [4 /*yield*/, effects_1.put(EnquiryFormActions_1.default.setEmailDisable(userEmail ? true : false))];
            case 3:
                _a.sent();
                _a.label = 4;
            case 4: return [3 /*break*/, 0];
            case 5: return [2 /*return*/];
        }
    });
};
var enquireSagas = {
    watchEmailBlur: watchEmailBlur,
    watchPhoneBlur: watchPhoneBlur,
    watchCountryCodeChanged: watchCountryCodeChanged,
    watchNameBlur: watchNameBlur,
    watchOnEnquirySubmit: watchOnEnquirySubmit,
    watchOnEnquiryContactSubmit: watchOnEnquiryContactSubmit,
    watchOnEnquireCloseClick: watchOnEnquireCloseClick,
    watchOnEnquireSubmit: watchOnEnquireSubmit,
    watchOnEnquiryWhatsAppSubmit: watchOnEnquiryWhatsAppSubmit,
    watchPopupSetEmailDisable: watchPopupSetEmailDisable,
    watchOnEnquireTop: watchOnEnquireTop,
    watchOnSetUser: watchOnSetUser,
    watchFilterChangePopSaveSearchFromLocalStorage: watchFilterChangePopSaveSearchFromLocalStorage,
    watchAfterEnquireNoLogin: watchAfterEnquireNoLogin,
    watchAfterEnquireCancelLoginSaga: watchAfterEnquireCancelLoginSaga,
    watchOnEnquireClicked: watchOnEnquireClicked,
    watchOnContactNumberClicked: watchOnContactNumberClicked,
    watchEnquireClose: watchEnquireClose,
    watchUpdateReplybar: watchUpdateReplybar,
    watchEnquireCallToActionClick: watchEnquireCallToActionClick,
    watchEnquireCallToAction: watchEnquireCallToAction,
};
exports.enquireSagas = enquireSagas;
